/**
 * Night-mode runner. Watches the active palette and the night-brightness setting
 * and pushes them live onto the page: a data attribute the shell CSS red-shifts
 * its surfaces off, plus a dim-veil CSS variable a brightness slider drives.
 * Mirrors GlassRunner. Renders nothing.
 */
import { useEffect } from 'react';
import { useChartPlotterStore } from '@/store';
import { useSettingsStore } from '@/store/settings';
import { applyNight } from '@/ui/night';

export function NightRunner() {
  const palette = useChartPlotterStore((s) => s.palette);
  const nightBrightness = useSettingsStore((s) => s.nightBrightness);
  useEffect(() => {
    applyNight(palette, nightBrightness);
  }, [palette, nightBrightness]);
  return null;
}
